import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";

const PagePlaceholder = ({ title, description, breadcrumbs }) => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <>
      <SEO title={title} description={description} path={location.pathname} />
      <section className="mx-auto max-w-[1240px] px-6 lg:px-10 py-16 lg:py-24">
        {breadcrumbs && <div className="mb-8"><Breadcrumbs items={breadcrumbs} /></div>}
        <p className="text-xs uppercase tracking-[0.2em] text-[var(--pharma-blue)] mb-4">
          {t("placeholder.coming_soon")}
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[var(--navy)] max-w-3xl leading-[1.05]">
          {title}
        </h1>
        {description && (
          <p className="mt-6 text-base sm:text-lg text-[var(--slate)] max-w-2xl leading-relaxed">
            {description}
          </p>
        )}
        <p className="mt-10 text-sm text-[var(--slate)] max-w-2xl">
          {t("placeholder.coming_soon_body")}
        </p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/contact" className="btn-primary text-sm" data-testid="placeholder-cta-contact">
            {t("nav.cta_talk")}
          </Link>
          <Link to="/request-sample" className="btn-outline text-sm" data-testid="placeholder-cta-sample">
            {t("nav.cta_sample")}
          </Link>
        </div>
      </section>
    </>
  );
};

export default PagePlaceholder;
